import _defineProperty from "/Users/mac/dev/larcade/ddl-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _objectSpread2;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { inputTheme } from "./chunk-WFLWAEKG.mjs";

// src/components/select.ts
import { selectAnatomy as parts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, cssVar, defineStyle } from "@chakra-ui/styled-system";
var _createMultiStyleConf = createMultiStyleConfigHelpers(parts.keys),
  defineMultiStyleConfig = _createMultiStyleConf.defineMultiStyleConfig,
  definePartsStyle = _createMultiStyleConf.definePartsStyle;
var $bg = cssVar("select-bg");
var _a;
var baseStyleField = defineStyle(_objectSpread(_objectSpread({}, (_a = inputTheme.baseStyle) == null ? void 0 : _a.field), {}, (_objectSpread2 = {
  appearance: "none",
  paddingBottom: "1px",
  lineHeight: "normal",
  bg: $bg.reference
}, _defineProperty(_objectSpread2, $bg.variable, "colors.white"), _defineProperty(_objectSpread2, "_dark", _defineProperty({}, $bg.variable, "colors.gray.700")), _defineProperty(_objectSpread2, "> option, > optgroup", {
  bg: $bg.reference
}), _objectSpread2)));
var baseStyleIcon = defineStyle({
  width: "6",
  height: "100%",
  insetEnd: "2",
  position: "relative",
  color: "currentColor",
  fontSize: "xl",
  _disabled: {
    opacity: 0.5
  }
});
var baseStyle = definePartsStyle({
  field: baseStyleField,
  icon: baseStyleIcon
});
var iconSpacing = defineStyle({
  paddingInlineEnd: "8"
});
var _a2, _b, _c, _d, _e, _f, _g, _h;
var sizes = {
  lg: _objectSpread(_objectSpread({}, (_a2 = inputTheme.sizes) == null ? void 0 : _a2.lg), {}, {
    field: _objectSpread(_objectSpread({}, (_b = inputTheme.sizes) == null ? void 0 : _b.lg.field), iconSpacing)
  }),
  md: _objectSpread(_objectSpread({}, (_c = inputTheme.sizes) == null ? void 0 : _c.md), {}, {
    field: _objectSpread(_objectSpread({}, (_d = inputTheme.sizes) == null ? void 0 : _d.md.field), iconSpacing)
  }),
  sm: _objectSpread(_objectSpread({}, (_e = inputTheme.sizes) == null ? void 0 : _e.sm), {}, {
    field: _objectSpread(_objectSpread({}, (_f = inputTheme.sizes) == null ? void 0 : _f.sm.field), iconSpacing)
  }),
  xs: _objectSpread(_objectSpread({}, (_g = inputTheme.sizes) == null ? void 0 : _g.xs), {}, {
    field: _objectSpread(_objectSpread({}, (_h = inputTheme.sizes) == null ? void 0 : _h.xs.field), iconSpacing),
    icon: {
      insetEnd: "1"
    }
  })
};
var selectTheme = defineMultiStyleConfig({
  baseStyle: baseStyle,
  sizes: sizes,
  variants: inputTheme.variants,
  defaultProps: inputTheme.defaultProps
});
export { selectTheme };